(function () {
  if (window.submitCartBundle) return;

  function showBundleError(errorEl, message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearBundleError(errorEl) {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function finishSubmitLoading(submitBtn) {
    submitBtn.removeAttribute('aria-disabled');
    submitBtn.classList.remove('loading');
    var spinner = submitBtn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  // Shared multi-line-item "add configured bundle to cart" flow, used by any
  // configurator (seat-configurator, modular-configurator, ...) that needs to
  // POST several cart items at once under one _bundle_id. Each caller only
  // supplies how to build its own `items` array (buildItems) - everything
  // else (loading state, /cart/add.js request, cart-drawer refresh, pubsub
  // events, error copy) is identical across configurators.
  window.submitCartBundle = function (options) {
    var form = options.form;
    var submitBtn = options.submitBtn;
    var errorEl = options.errorEl;
    var buildItems = options.buildItems;
    var i18n = options.i18n || {};
    var source = options.source;

    clearBundleError(errorEl);

    // Callers whose quantity input isn't a DOM descendant of `form` (e.g.
    // it lives in a different section block, associated only via the
    // input's `form="..."` attribute) can pass it explicitly; otherwise
    // fall back to searching inside the form, as before.
    var quantityInput = options.quantityInput || form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var items = buildItems(quantity);

    if (!items || !items.length) {
      showBundleError(errorEl, i18n.missingVariant);
      return;
    }

    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    var spinner = submitBtn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    var config = fetchConfig('json');
    config.body = JSON.stringify(body);

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        finishSubmitLoading(submitBtn);

        if (response.status) {
          showBundleError(errorEl, response.description || response.message || i18n.genericError);
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: source,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (cart) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: source });
        }
      })
      .catch(function () {
        finishSubmitLoading(submitBtn);
        showBundleError(errorEl, i18n.genericError);
      });
  };
})();
